// Two independent triggers:
//   1. "completed"  — the pending-inward count just transitioned from >0 to 0
//                     (i.e. the last inward was completed by the bot / operator).
//   2. "inactivity" — no inward activity for longer than the inactivity limit.
// Kept as a pure function so the trigger logic is unit-testable in isolation.

export const INWARD_INACTIVITY_LIMIT_MS = 5 * 60 * 1000; // 5 minutes

export type ExitPromptReason = "completed" | "inactivity";

export interface ExitPromptInput {
  inwardActive: boolean;
  promptOpen: boolean;
  previousPendingCount: number;
  currentPendingCount: number;
  inactivityElapsedMs: number;
  inactivityLimitMs?: number;
}

export function evaluateExitPrompt(
  input: ExitPromptInput
): ExitPromptReason | null {
  const {
    inwardActive,
    promptOpen,
    previousPendingCount,
    currentPendingCount,
    inactivityElapsedMs,
    inactivityLimitMs = INWARD_INACTIVITY_LIMIT_MS,
  } = input;

  // Never prompt when inward isn't running or a prompt is already showing.
  if (!inwardActive || promptOpen) {
    return null;
  }

  // The last pending inward just finished.
  if (previousPendingCount > 0 && currentPendingCount === 0) {
    return "completed";
  }

  // Operator has been idle past the limit.
  if (inactivityElapsedMs >= inactivityLimitMs) {
    return "inactivity";
  }

  return null;
}
